import Settings from '../../resources/settings';
import commonStrings from '../../resources/commonStrings';
import { roleLevels } from '../../resources/roles';
import { getAvailableReports } from '../utils';

const audienceFilters = {
  assessmentCoordinator: commonStrings.reportAudienceFilters.assessmentCoordinator,
  counselor: commonStrings.reportAudienceFilters.counselor,
  curriculumSpecialist: commonStrings.reportAudienceFilters.curriculumSpecialist,
  instructionalCoach: commonStrings.reportAudienceFilters.instructionalCoach,
  parent: commonStrings.reportAudienceFilters.parent,
  principal: commonStrings.reportAudienceFilters.principal,
  student: commonStrings.reportAudienceFilters.student,
  superintendent: commonStrings.reportAudienceFilters.superintendent,
  teacher: commonStrings.reportAudienceFilters.teacher,
};

export const allFilter = 'all';

export const levelFilters = {
  all: allFilter,
  class: 'classLevel',
  schoolOrDistrict: 'schoolOrDistrictLevel',
  student: 'studentLevel',
};

export const ReportLevelItems = [
  {
    displayText: commonStrings.reportLevelFilters.student,
    value: levelFilters.student,
    isDisabled: false,
  },
  {
    displayText: commonStrings.reportLevelFilters.class,
    value: levelFilters.class,
    isDisabled: false,
  },
  {
    displayText: commonStrings.reportLevelFilters.school,
    value: levelFilters.schoolOrDistrict,
    isDisabled: false,
  },
  {
    displayText: commonStrings.reportLevelFilters.schoolOrDistrict,
    value: levelFilters.schoolOrDistrict,
    isDisabled: false,
  },
  {
    displayText: commonStrings.reportLevelFilters.all,
    value: levelFilters.all,
    isDisabled: false,
  },
];

export const whatImDoingFilters = {
  all: allFilter,
  groupingStudents: 'groupingStudents',
  monitoringGrowth: 'monitoringGrowth',
  planningInstruction: 'planningInstruction',
  talkingWithFamiliesAndStudents: 'talkingWithFamiliesAndStudents',
  viewingStudentTestResultDetails: 'viewingStudentTestResultDetails',
};

export const WhatImDoingItems = [
  {
    displayText: commonStrings.reportWhatImDoingFilters.viewingStudentTestResultDetails,
    value: whatImDoingFilters.viewingStudentTestResultDetails,
    isDisabled: false,
  },
  {
    displayText: commonStrings.reportWhatImDoingFilters.monitoringGrowth,
    value: whatImDoingFilters.monitoringGrowth,
    isDisabled: false,
  },
  {
    displayText: commonStrings.reportWhatImDoingFilters.planningInstruction,
    value: whatImDoingFilters.planningInstruction,
    isDisabled: false,
  },
  {
    displayText: commonStrings.reportWhatImDoingFilters.groupingStudents,
    value: whatImDoingFilters.groupingStudents,
    isDisabled: false,
  },
  {
    displayText: commonStrings.reportWhatImDoingFilters.talkingWithFamiliesAndStudents,
    value: whatImDoingFilters.talkingWithFamiliesAndStudents,
    isDisabled: false,
  },
  {
    displayText: commonStrings.reportWhatImDoingFilters.all,
    value: whatImDoingFilters.all,
    isDisabled: false,
  },
];

export const sortingMethods = {
  asc: 'asc',
  desc: 'desc',
  recommended: 'recommended',
};

export const reportDetails = [
  {
    identifier: 'batchServiceFamilyReport',
    imageName: 'batchServiceFamilyReport',
    filter: {
      audience: [
        audienceFilters.instructionalCoach,
        audienceFilters.teacher,
        audienceFilters.counselor,
        audienceFilters.student,
        audienceFilters.parent,
      ],
      level: [levelFilters.student],
      whatImDoing: [whatImDoingFilters.talkingWithFamiliesAndStudents],
    },
    sortingWeights: {
      recommended: 18,
    },
    title: commonStrings.reportTitle.batchServiceFamilyReport,
    linkTarget: `${Settings.BASE_URL}/profile/batch-report/family`,
    details: {
      listItems: commonStrings.reportDetailsList.batchServiceFamilyReport,
    },
    isEnabled: true,
  },
  {
    identifier: 'classProfile',
    imageName: 'classProfile',
    filter: {
      audience: [audienceFilters.instructionalCoach, audienceFilters.teacher, audienceFilters.counselor],
      level: [levelFilters.class],
      whatImDoing: [
        whatImDoingFilters.viewingStudentTestResultDetails,
        whatImDoingFilters.planningInstruction,
        whatImDoingFilters.groupingStudents,
      ],
    },
    sortingWeights: {
      recommended: 22,
    },
    title: commonStrings.reportTitle.classProfile,
    linkTarget: `${Settings.BASE_URL}/profile/class/test-details`,
    details: {
      listItems: commonStrings.reportDetailsList.classProfile,
    },
    isEnabled: true,
  },
  {
    identifier: 'asgProjectionSummary',
    imageName: 'asgProjectionSummary',
    filter: {
      audience: [audienceFilters.instructionalCoach, audienceFilters.teacher, audienceFilters.counselor],
      level: [levelFilters.class],
      whatImDoing: [whatImDoingFilters.viewingStudentTestResultDetails, whatImDoingFilters.monitoringGrowth],
    },
    sortingWeights: {
      recommended: 12,
    },
    title: commonStrings.reportTitle.asgProjectionSummary,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/asgClassReport.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.asgProjectionSummary,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.asgProjectionSummary,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleASGProjectionandSummary.pdf',
    },
    isEnabled: true,
  },
  {
    identifier: 'asgQuadrant',
    imageName: 'asgQuadrant',
    filter: {
      audience: [audienceFilters.instructionalCoach, audienceFilters.teacher, audienceFilters.counselor],
      level: [levelFilters.class],
      whatImDoing: [
        whatImDoingFilters.viewingStudentTestResultDetails,
        whatImDoingFilters.monitoringGrowth,
        whatImDoingFilters.planningInstruction,
        whatImDoingFilters.groupingStudents,
      ],
    },
    title: commonStrings.reportTitle.asgQuadrant,
    sortingWeights: { recommended: 13 },
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/asgOnlineReport`,
    details: {
      listItems: commonStrings.reportDetailsList.asgQuadrant,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.asgQuadrant,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleASGSummarywithQuadrantChart.pdf',
    },
    isEnabled: true,
  },
  {
    identifier: 'learningContinuum',
    imageName: 'learningContinuum',
    filter: {
      audience: [audienceFilters.instructionalCoach, audienceFilters.teacher, audienceFilters.counselor],
      level: [levelFilters.class],
      whatImDoing: [whatImDoingFilters.planningInstruction, whatImDoingFilters.groupingStudents],
    },
    sortingWeights: { recommended: 15 },
    title: commonStrings.reportTitle.learningContinuum,
    linkTarget: `${Settings.BASE_URL}/learning-continuum`,
    details: {
      listItems: commonStrings.reportDetailsList.learningContinuum,
    },
    isEnabled: true,
  },
  {
    identifier: 'studentProgress',
    imageName: 'studentProgress',
    filter: {
      audience: [
        audienceFilters.instructionalCoach,
        audienceFilters.teacher,
        audienceFilters.counselor,
        audienceFilters.student,
        audienceFilters.parent,
      ],
      level: [levelFilters.student],
      whatImDoing: [
        whatImDoingFilters.viewingStudentTestResultDetails,
        whatImDoingFilters.monitoringGrowth,
        whatImDoingFilters.planningInstruction,
        whatImDoingFilters.talkingWithFamiliesAndStudents,
      ],
    },
    sortingWeights: { recommended: 11 },
    title: commonStrings.reportTitle.studentProgressReport,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/studentProgressReport.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.studentProgressReport,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.studentProgress,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleStudentProgress.pdf',
    },
    isEnabled: true,
  },
  {
    identifier: 'studentProfile',
    imageName: 'studentProfile',
    filter: {
      audience: [
        audienceFilters.instructionalCoach,
        audienceFilters.teacher,
        audienceFilters.counselor,
        audienceFilters.student,
        audienceFilters.parent,
      ],
      level: [levelFilters.student],
      whatImDoing: [
        whatImDoingFilters.viewingStudentTestResultDetails,
        whatImDoingFilters.monitoringGrowth,
        whatImDoingFilters.planningInstruction,
        whatImDoingFilters.talkingWithFamiliesAndStudents,
      ],
    },
    sortingWeights: { recommended: 19 },
    title: commonStrings.reportTitle.studentProfile,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/nextgen-report/`,
    details: {
      listItems: commonStrings.reportDetailsList.studentProfile,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.studentProfile,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleStudentProfile.pdf',
    },
    isEnabled: true,
  },
  {
    identifier: 'screeningAndSkillsChecklistClass',
    imageName: 'screeningAndSkillsChecklistClass',
    filter: {
      audience: [
        audienceFilters.instructionalCoach,
        audienceFilters.teacher,
        audienceFilters.counselor,
        audienceFilters.student,
        audienceFilters.parent,
      ],
      level: [levelFilters.class],
      whatImDoing: [
        whatImDoingFilters.viewingStudentTestResultDetails,
        whatImDoingFilters.planningInstruction,
        whatImDoingFilters.groupingStudents,
      ],
    },
    sortingWeights: { recommended: 8 },
    title: commonStrings.reportTitle.screeningAndSkillsChecklistClass,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/mpgInstructorSelection.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.screeningAndSkillsChecklistClass,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.screeningAndSkillsChecklistClass,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleScreeningandSkillsChecklistClass.pdf',
    },
    isEnabled: true,
  },
  {
    identifier: 'screeningAndSkillsChecklistStudent',
    imageName: 'screeningAndSkillsChecklistStudent',
    filter: {
      audience: [
        audienceFilters.instructionalCoach,
        audienceFilters.teacher,
        audienceFilters.counselor,
        audienceFilters.student,
        audienceFilters.parent,
      ],
      level: [levelFilters.student],
      whatImDoing: [
        whatImDoingFilters.viewingStudentTestResultDetails,
        whatImDoingFilters.planningInstruction,
        whatImDoingFilters.groupingStudents,
      ],
    },
    sortingWeights: { recommended: 9 },
    title: commonStrings.reportTitle.screeningAndSkillsChecklistStudent,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/mpgStudentSelection.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.screeningAndSkillsChecklistStudent,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.screeningAndSkillsChecklistStudent,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleScreeningandSkillsChecklistStudent.pdf',
    },
    isEnabled: true,
  },
  {
    identifier: 'districtSummary',
    imageName: 'districtSummary',
    filter: {
      audience: [
        audienceFilters.superintendent,
        audienceFilters.curriculumSpecialist,
        audienceFilters.instructionalCoach,
        audienceFilters.principal,
      ],
      level: [levelFilters.schoolOrDistrict],
      whatImDoing: [],
    },
    sortingWeights: { recommended: 2 },
    title: commonStrings.reportTitle.districtSummary,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/districtSummary.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.districtSummary,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.districtSummary,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleDistrictSummary.pdf',
    },
    isEnabled: true,
  },
  // TODO: Remove this report in future. https://nwea.atlassian.net/browse/MAPR-1298
  {
    identifier: 'familyReport',
    imageName: 'familyReport',
    filter: {
      audience: [
        audienceFilters.instructionalCoach,
        audienceFilters.teacher,
        audienceFilters.counselor,
        audienceFilters.student,
        audienceFilters.parent,
      ],
      level: [levelFilters.student],
      whatImDoing: [whatImDoingFilters.talkingWithFamiliesAndStudents],
    },
    sortingWeights: { recommended: 17 },
    title: commonStrings.reportTitle.familyReport,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/nextgen-report/family-report`,
    details: {
      listItems: commonStrings.reportDetailsList.familyReport,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.familyReport,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleFamily.pdf',
    },
    video: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.familyReportVideo,
      linkTarget: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=855',
    },
    isEnabled: false,
  },
  {
    identifier: 'grade',
    imageName: 'grade',
    // launchDarklyToggleFlagName: 'insightsProfileUi793734RetireReports',
    filter: {
      audience: [audienceFilters.instructionalCoach, audienceFilters.counselor, audienceFilters.principal],
      level: [levelFilters.schoolOrDistrict],
      whatImDoing: [whatImDoingFilters.viewingStudentTestResultDetails],
    },
    sortingWeights: { recommended: 7 },
    title: commonStrings.reportTitle.grade,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/gradeReport.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.grade,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.grade,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleGrade.pdf',
    },
    isEnabled: true,
  },
  {
    identifier: 'gradeBreakdown',
    imageName: 'gradeBreakdown',
    // launchDarklyToggleFlagName: 'insightsProfileUi793734RetireReports',
    filter: {
      audience: [audienceFilters.instructionalCoach, audienceFilters.counselor, audienceFilters.principal],
      level: [levelFilters.schoolOrDistrict],
      whatImDoing: [
        whatImDoingFilters.viewingStudentTestResultDetails,
        whatImDoingFilters.planningInstruction,
        whatImDoingFilters.groupingStudents,
      ],
    },
    sortingWeights: { recommended: 6 },
    title: commonStrings.reportTitle.gradeBreakdown,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/gradeBreakdownReport.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.gradeBreakdown,
    },
    isEnabled: true,
  },
  {
    identifier: 'projectedProficiencySummary',
    imageName: 'projectedProficiencySummary',
    filter: {
      audience: [
        audienceFilters.superintendent,
        audienceFilters.curriculumSpecialist,
        audienceFilters.instructionalCoach,
        audienceFilters.principal,
      ],
      level: [levelFilters.schoolOrDistrict],
      whatImDoing: [],
    },
    sortingWeights: { recommended: 4 },
    title: commonStrings.reportTitle.projectedProficiencySummary,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/projectedProficiencySummary.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.projectedProficiencySummary,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.projectedProficiencySummary,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleProjectedProficiencySummary.pdf',
    },
    isEnabled: true,
  },
  {
    identifier: 'studentGrowthSummary',
    imageName: 'studentGrowthSummary',
    filter: {
      audience: [
        audienceFilters.superintendent,
        audienceFilters.curriculumSpecialist,
        audienceFilters.instructionalCoach,
        audienceFilters.principal,
      ],
      level: [levelFilters.schoolOrDistrict],
      whatImDoing: [whatImDoingFilters.monitoringGrowth],
    },
    sortingWeights: { recommended: 3 },
    title: commonStrings.reportTitle.studentGrowthSummary,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/studentGrowthSummary.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.studentGrowthSummary,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.studentGrowthSummary,
      linkTarget: 'https://dpdol.nwea.org/public/growth/GR_SampleStudentGrowthSummary.pdf',
    },
    isEnabled: true,
  },
  {
    identifier: 'dataExportScheduler',
    imageName: 'dataExportScheduler',
    filter: {
      audience: [audienceFilters.assessmentCoordinator],
      level: [levelFilters.schoolOrDistrict],
      whatImDoing: [whatImDoingFilters.viewingStudentTestResultDetails, whatImDoingFilters.monitoringGrowth],
    },
    sortingWeights: { recommended: 1 },
    title: commonStrings.reportTitle.dataExportScheduler,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/map/comprehensiveDataFile.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.dataExportScheduler,
    },
    isEnabled: true,
  },
  {
    identifier: 'dataExportSchedulerBeta',
    imageName: 'dataExportScheduler',
    // Launch Darkly feature flag mapping: insights2867CsvDataExporter --> INSIGHTS_2867_CSV_DATA_EXPORTER
    launchDarklyToggleFlagName: 'insights2867CsvDataExporter',
    filter: {
      audience: [audienceFilters.assessmentCoordinator],
      level: [levelFilters.schoolOrDistrict],
      whatImDoing: [whatImDoingFilters.viewingStudentTestResultDetails, whatImDoingFilters.monitoringGrowth],
    },
    sortingWeights: { recommended: 0 },
    title: commonStrings.reportTitle.dataExportSchedulerBeta,
    linkTarget: `${Settings.BASE_URL}/profile/batch-report/data-export`,
    details: {
      listItems: commonStrings.reportDetailsList.dataExportScheduler,
    },
    isEnabled: true,
  },
  {
    identifier: 'recoveryGoalSetting',
    imageName: 'recoveryGoalSetting',
    filter: {
      audience: [audienceFilters.assessmentCoordinator],
      level: [levelFilters.schoolOrDistrict],
      whatImDoing: [
        whatImDoingFilters.viewingStudentTestResultDetails,
        whatImDoingFilters.monitoringGrowth,
        whatImDoingFilters.planningInstruction,
      ],
    },
    sortingWeights: { recommended: 20 },
    title: commonStrings.reportTitle.recoveryGoalSettingReport,
    linkTarget: `${Settings.URL_BASE_PATH}recoverygoal-setting`,
    details: {
      listItems: commonStrings.reportDetailsList.recoveryGoalSettingReport,
    },
    footer: {
      linkDisplayText: commonStrings.reportFooterLinkDisplayText.recoveryGoalSettingReport,
      linkTarget: 'https://teach.mapnwea.org/impl/maphelp/ApplicationHelp.htm#cshid=635',
    },
    isEnabled: false,
  },
  {
    identifier: 'schoolLevelInsights',
    imageName: 'schoolLevelInsightsV2',
    filter: {
      audience: [audienceFilters.principal, audienceFilters.assessmentCoordinator],
      level: [levelFilters.schoolOrDistrict],
      whatImDoing: [whatImDoingFilters.viewingStudentTestResultDetails],
    },
    sortingWeights: { recommended: 25 },
    title: commonStrings.reportTitle.schoolLevelInsightsReport,
    linkTarget: `${Settings.URL_BASE_PATH}profile/school/achievement`,
    details: {
      listItems: commonStrings.reportDetailsList.schoolLevelInsights,
    },
    isEnabled: true,
  },
  {
    identifier: 'districtLevelInsights',
    imageName: 'districtProfile',
    filter: {
      audience: [audienceFilters.assessmentCoordinator],
      level: [levelFilters.schoolOrDistrict],
      whatImDoing: [],
    },
    sortingWeights: { recommended: 26 },
    title: commonStrings.reportTitle.districtProfile,
    linkTarget: `${Settings.URL_BASE_PATH}profile/district/achievement`,
    details: {
      listItems: commonStrings.reportDetailsList.districtProfile,
    },
    isEnabled: true,
  },
];

export const getGrowthReportsHeaderText = (roleLevel, levelFilter, doingFilter) => {
  const roleBasedLevelItems = ReportLevelItems.filter((item) => {
    return (
      item.value !== levelFilters.schoolOrDistrict ||
      (roleLevel === roleLevels.district && item.displayText === commonStrings.reportLevelFilters.schoolOrDistrict) ||
      (roleLevel === roleLevels.school && item.displayText === commonStrings.reportLevelFilters.school)
    );
  });
  const showAllLevels = levelFilter === levelFilters.all;
  const showAllDoing = doingFilter === whatImDoingFilters.all;
  const selectedDoing = WhatImDoingItems.find((item) => item.value === doingFilter);
  const selectedLevel = roleBasedLevelItems.find((item) => item.value === levelFilter);
  const showingText = showAllLevels || showAllDoing ? 'Showing All Reports' : 'Showing Reports';
  const whatImDoingText = showAllDoing ? '' : ` for ${selectedDoing.displayText}`;
  const reportLevelText = showAllLevels ? '' : ` at the ${selectedLevel.displayText.replace('-level', ' Level')}`;
  const headingText = `${showingText}${whatImDoingText}${reportLevelText}`;
  return headingText;
};

export const reportIdentifiers = getAvailableReports(reportDetails, ['studentQuickSearch']);

export default {
  allFilter,
  reportDetails,
  levelFilters,
  ReportLevelItems,
  WhatImDoingItems,
  whatImDoingFilters,
  sortingMethods,
  getGrowthReportsHeaderText,
  reportIdentifiers,
};
